import * as React from 'react';
import { useSelector } from 'react-redux';

import { SpecialProjectBannerSkeleton } from '../../components/SpecialProjectBannerSkeleton';
import { selectLocationIdForAdfox } from '../../selectors/selectLocationIdForAdfox';
import { addAdFoxBanner, getRandomId } from '../../serp/components/adfox';

export function SpecialProjectBannerContainer() {
  const locationId = useSelector(selectLocationIdForAdfox);
  const [isVisibleBanner, setIsVisibleBanner] = React.useState(true);

  const banner = React.useMemo(() => {
    return addAdFoxBanner({
      type: 'special_project_banner',
      key: 'special_project_banner',
      onError: () => setIsVisibleBanner(false),
      onStub: () => setIsVisibleBanner(false),
      additionalPuids: {
        puid2: 'offer_flat',
        puid3: 'sale_type_first',
        puid5: `obl_id_${locationId}`,
        pr: getRandomId(),
      },
      isNew: true,
      width: '100%',
      minHeight: '148px',
      postViewAnalyticsData: {
        banner: {
          place: 'offersSerp',
          name: 'Special_project_adfox',
          extra: {
            offerType: 'banner',
          },
        },
      },
    });
  }, [locationId]);

  if (!isVisibleBanner) {
    return null;
  }

  return <SpecialProjectBannerSkeleton>{banner}</SpecialProjectBannerSkeleton>;
}
